
import { useParams } from 'react-router-dom';
import ActivityHistoryLogs from '../../../component/users/organization-admin/activity-logs/ActivityLogs';
 
function ActivityLogs() {
  const { id } = useParams();
  return (
    <div className='page-body'>
        <ActivityHistoryLogs userId={id}/>
  </div>
  )
}

export default ActivityLogs
